module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/JFK.9e897f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/JFK.jpg
// module id = 29La
// module chunks = 0